import React from 'react';
import { Label, Input, Circle } from './style.js';

function Radio(_a) {
    var name = _a.name, value = _a.value, _b = _a.checked, checked = _b === void 0 ? false : _b, onChange = _a.onChange, children = _a.children, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var handleChange = function (event) {
        if (disabled)
            return;
        if (onChange) {
            onChange({
                name: event.target.name,
                value: event.target.value,
                label: children || 'label',
            });
        }
    };
    return (React.createElement(Label, { disabled: disabled },
        React.createElement(Input, { name: name, value: value, type: "radio", onChange: handleChange, checked: checked, disabled: disabled }),
        React.createElement(Circle, null),
        children));
}

export { Radio as default };
